<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'branches.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Logo</th>
                                        <th>Nome</th>
                                        <th>CPF/CNPJ</th>
                                        <th>Ativo</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="items.length > 0"
                                        v-for="iterator in items" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>
                                            <md-avatar class="md-large">
                                                <img :src="apiBaseUrl + '/' + iterator.logo">
                                            </md-avatar>
                                        </td>
                                        <td>{{ iterator.name }}</td>
                                        <td>{{ iterator.cpf_cnpj | cpf_cnpj }}</td>
                                        <td>
                                            <span class="badge badge-pill" v-bind:class="{'badge-danger' : !iterator.is_active, 'badge-success' : iterator.is_active}">
                                                {{ iterator.is_active ? 'Ativa' : 'Inativa' }}
                                            </span>
                                        </td>
                                        <td class="td-actions text-right">
                                            <index-buttons
                                                :iterator=iterator
                                                :showAudit="false"
                                                :toAudit="{name: 'dashboard'}"
                                                :showEdit="true"
                                                :toEdit="{name: 'branches.edit', params: { id: iterator.id }}"
                                                :showRemove="true"
                                                dispatchRemove="branches/rem"
                                                :callbackRemove="getData"
                                                >
                                            </index-buttons>
                                        </td>
                                    </tr>
                                    <tr v-show="items.length==0">
                                        <td colspan="5">Nenhuma filial encontrada!</td>
                                    </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import Service from "@/services/api.service.js";
    export default {
        computed: {
            items() {
                return this.$store.state.branches.itens;
            }
        },
        created: function () {
            this.getData();
        },
        data() {
            return {
                apiBaseUrl: Service.getBaseUrl(),
                currentPage: 1
            };
        },
        methods: {
            remove: function (_item) {
                var self = this;
                this.$dialog.confirm('Deseja realmente remover a filial "' + _item.name + '"?')
                        .then(function () {
                            self.$root.$emit('onLoading');

                            const response = self.$store.dispatch('branches/rem', _item);

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Filial excluída com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir a filial!");
                            });
                        });
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('branches/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    }
</script>